import { createFileRoute, redirect } from '@tanstack/react-router'
import { EMAIL_INTERFACE_ENABLED } from '@/lib/env'
import EmailAgentSettings from '@/pages/settings/email'

export const Route = createFileRoute(
  '/(protected)/workspaces/$workspaceId/settings/email'
)({
  // The page advertises `{slug}@screenata.com`; while the interface is off that
  // address bounces, so don't show it even by direct link.
  beforeLoad: ({ params }) => {
    if (!EMAIL_INTERFACE_ENABLED) {
      throw redirect({
        to: '/workspaces/$workspaceId/settings/profile',
        params,
      })
    }
  },
  component: RouteComponent,
})

function RouteComponent() {
  return <EmailAgentSettings />
}
